import React, { useEffect } from 'react';
import { IFooterComponentProps } from '../../../../.starryUI/grids/ServerPagedGrid/Footer';
import { Button, HStack, Text } from '@starrez/starryui9';
import { ToggleSwitchWithLabel } from '../../../../.starryUI/Buttons/ToggleSwitchWithLabel/ToggleSwitchWithLabel';
import { useEntryDirectoryEvents } from '../context/EntryDirectoryContext';
import { useQuestionInput } from '../../../../.starryUI/Popups/QuestionInput';
import { useMainDirectorySelectedQuery } from '../graphql/useMainDirectorySelectedQuery';
import { strings } from '@starryui10/localisation';

interface IDirectoryFooterProps extends IFooterComponentProps {
    onClearSelection: () => void;
    onShowSelected: (value: boolean) => void;
}

export const DirectoryFooter: React.FC<IDirectoryFooterProps> = ({ onClearSelection, onHide, onShow, onShowSelected }) => {
    const { openActionsPopup, saveSelected } = useEntryDirectoryEvents();
    const [Popup, showPopup] = useQuestionInput();
    const { data } = useMainDirectorySelectedQuery();

    const handleClearSelection = () => {
        showPopup().then((res) => {
            if (res.val === 'Yes') {
                onClearSelection();
            }
        });
    };

    const updateShowSelected = (value: boolean) => {
        onShowSelected(value);
    }

    useEffect(() => {
        if (!data?.allMainDirectory?.totalSelectedCount) {
            onHide();
        } else {
            onShow();
        }
    }, [data?.allMainDirectory?.totalSelectedCount, onHide, onShow]);

    return (
        <>
            <HStack gap="small" height="100%" columns="max-content">
                <HStack>
                    <Text variant="large.bold">{data?.allMainDirectory.totalSelectedCount} selected</Text>
                </HStack>
                <div>
                    <Button onClick={openActionsPopup} variant="Primary">{`Actions (${data?.allMainDirectory.totalSelectedCount})`}</Button>
                </div>
                <div>
                    <ToggleSwitchWithLabel ariaLabel="Show only Selected" caption="Show only Selected" onClick={updateShowSelected} />
                </div>
                <Button onClick={saveSelected} variant="Ghost">
                    {strings.Action_SaveSelected}
                </Button>
                <Button onClick={handleClearSelection} variant="Ghost">
                    {strings.Action_ClearSelected}
                </Button>
            </HStack>

            <Popup variant="YesNo" header="Entry Directory" message="Clear all the selected items?" />
        </>
    );
};
